import type { JobStatus, PaymentStatus, VerificationStatus, AccountStatus } from '../types';

export const mapIdentityStatus = (status?: string): VerificationStatus => {
  switch ((status || '').toLowerCase()) {
    case 'approved':
      return 'Approved';
    case 'rejected':
      return 'Rejected';
    default:
      return 'Pending';
  }
};

export const mapBlockedStatus = (isBlocked?: boolean): AccountStatus =>
  isBlocked ? 'Deactivated' : 'Active';

export const mapJobStatus = (status?: string): JobStatus => {
  switch ((status || '').toLowerCase()) {
    case 'pending':
      return 'Pending';
    case 'active':
      return 'In Progress';
    case 'completed':
      return 'Completed';
    case 'canceled':
    case 'cancelled':
      return 'Cancelled';
    case 'disputed-ongoing':
      return 'In Progress';
    case 'disputed-resolved':
      return 'Completed';
    default:
      return 'Pending';
  }
};

export const mapPaymentStatus = (status?: string): PaymentStatus => {
  switch ((status || '').toLowerCase()) {
    case 'success':
    case 'successful':
    case 'completed':
      return 'Successful';
    case 'failed':
      return 'Failed';
    case 'cancelled':
    case 'canceled':
      return 'Cancelled';
    case 'refunded':
      return 'Refunded';
    default:
      return 'Pending';
  }
};

export const nameFrom = (value?: unknown): string => {
  if (!value) return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null && 'name' in value) {
    const name = (value as { name?: string | null }).name;
    return name?.trim() || '—';
  }
  return '—';
};
